var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { api } from "../../App/services/api";
function getTitles() {
    return api.get('/art-generator/titles').then(function (res) { return res.data; });
}
function getComboSvas() {
    return api.get('/art-generator/svas').then(function (res) { return res.data; });
}
function getProductGroups() {
    return api.get('/art-generator/product-groups').then(function (res) { return res.data.product_groups; });
}
function getColorCombinations() {
    return api.get('/art-generator/color-backgrounds').then(function (res) { return res.data; });
}
function getVelocities() {
    return Promise.resolve([
        { id: '1', label: '100', unitOptions: ['MEGA', 'GB'] },
        { id: '2', label: '200', unitOptions: ['MEGA', 'GB'] },
    ]);
}
function getImages() {
    return api.get('/art-generator/backgrounds').then(function (res) { return res.data; });
}
function getOrientations() {
    return api.get('/art-generator/orientations').then(function (res) { return res.data; });
}
function getAdditionalInfos() {
    return api.get('/art-generator/additional-infos').then(function (res) { return res.data; });
}
function getSvas() {
    return api.get('/art-generator/svas').then(function (res) { return res.data; });
}
function getCreatedArts() {
    return api.get('/art-generator/created-arts').then(function (res) { return res.data; });
}
function validateLogo(logo) {
    var formData = new FormData();
    formData.append('logo', logo);
    return api.post('/art-generator/validate-logo', formData).then(function (res) { return res.data; });
}
function storeGeneratedArt(payload) {
    return api.post('/art-generator/generated-arts', payload).then(function (res) { return res.data; });
}
function getLayouts() {
    return api.get('/art-generator/layouts').then(function (res) { return res.data; });
}
function createTitle(label) {
    return api.post('/art-generator/titles', { text: label }).then(function (res) { return res.data; });
}
function deleteTitle(id) {
    return api.delete("/art-generator/titles/".concat(id)).then(function (res) { return res.data; });
}
function createAdditionalInfo(value) {
    return api.post('/art-generator/additional-infos', { text: value }).then(function (res) { return res.data; });
}
function deleteAdditionalInfo(id) {
    return api.delete("/art-generator/additional-infos/".concat(id)).then(function (res) { return res.data; });
}
function createColorBackground(payload) {
    return api.post('/art-generator/color-backgrounds', __assign(__assign({}, payload), { is_active: 1 })).then(function (res) { return res.data; });
}
function deleteColorBackground(id) {
    return api.delete("/art-generator/color-backgrounds/".concat(id)).then(function (res) { return res.data; });
}
function uploadBackground(file, orientationId, productId) {
    var formData = new FormData();
    formData.append('image', file);
    formData.append('orientation_id', String(orientationId));
    if (productId != null)
        formData.append('content_supplier_product_id', String(productId));
    return api.post('/art-generator/backgrounds', formData).then(function (res) { return res.data.data; });
}
function deleteBackground(id) {
    return api.delete("/art-generator/backgrounds/".concat(id)).then(function (res) { return res.data; });
}
function getGeneratedArtById(id) {
    return api.get("/art-generator/generated-arts/".concat(id)).then(function (res) { return res.data; });
}
function updateGeneratedArt(id, payload) {
    return api.put("/art-generator/generated-arts/".concat(id), payload).then(function (res) { return res.data; });
}
function deleteGeneratedArt(id) {
    return api.delete("/art-generator/generated-arts/".concat(id)).then(function (res) { return res.data; });
}
export default {
    getTitles: getTitles,
    getComboSvas: getComboSvas,
    getProductGroups: getProductGroups,
    getColorCombinations: getColorCombinations,
    getVelocities: getVelocities,
    getImages: getImages,
    getOrientations: getOrientations,
    getAdditionalInfos: getAdditionalInfos,
    getCreatedArts: getCreatedArts,
    getSvas: getSvas,
    validateLogo: validateLogo,
    storeGeneratedArt: storeGeneratedArt,
    getLayouts: getLayouts,
    getGeneratedArtById: getGeneratedArtById,
    updateGeneratedArt: updateGeneratedArt,
    deleteGeneratedArt: deleteGeneratedArt,
    createTitle: createTitle,
    deleteTitle: deleteTitle,
    createAdditionalInfo: createAdditionalInfo,
    deleteAdditionalInfo: deleteAdditionalInfo,
    createColorBackground: createColorBackground,
    deleteColorBackground: deleteColorBackground,
    uploadBackground: uploadBackground,
    deleteBackground: deleteBackground
};
